import IProduct from 'models/product';
import { IFoodlaCategoryOption } from 'models/category';
import { evaluateRequiredFields } from 'generated/productRequirements/evaluate';
import type { ProductFieldRule } from 'generated/productRequirements/types';
import { PRODUCT_FIELD_RULES } from './productFieldRules';
import { ProductFieldRuleType, ProductValidations } from './type';

export type { ProductValidationError, ProductValidations } from './type';
export { EMPTY_PRODUCT_VALIDATIONS } from './type';

export type EvaluateProductValidationsParams = {
  state?: IProduct;
  rootCategory?: IFoodlaCategoryOption;
  /** Product-information files that will remain after saving (saved minus removed plus new). */
  productInfoFilesCount?: number;
  /**
   * Grandfathering: retailer rules apply only to new products and saved drafts,
   * so an already active product can be re-saved without the new fields.
   */
  applyRetailerRules: boolean;
  rules?: ProductFieldRuleType[];
};

/** The native save policy controls when retailer requirements gate submission. */
export const evaluateProductValidations = ({ state, rootCategory, productInfoFilesCount,
  applyRetailerRules, rules = PRODUCT_FIELD_RULES }: EvaluateProductValidationsParams): ProductValidations =>
  evaluateRequiredFields({ state, rootCategory, productInfoFilesCount, applyRetailerRules,
    retailers: state?.producerOrganizations || [], producerIsStore: state?.producerIsStore === true,
    rules: rules as ProductFieldRule[],
  }) as ProductValidations;
